<template>
    <div class="import-validation-container">
        <b-row class="header align-items-center mb-3 p-3">
            <b-col cols="12" md="8" class="header-left d-flex align-items-center">
                <i class="icon-list"></i>
                <h5 class="title ml-2 mt-2">{{ mergedOptions.title }}</h5>
            </b-col>
            <b-col cols="12" md="4" class="d-flex justify-content-end">
                <div v-if="mergedOptions.textImport" class="header-right">
                    <span>Total: {{ mergedOptions.totalImport }}</span>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12" md="12" v-if="mergedOptions.validationErrors.length > 0">
                <div class="no-errors">
                    <div class="error-message">
                        <i class="icon-close"></i>
                        <span>{{ mergedOptions.errorMessage }}</span>
                    </div>
                </div>
                <b-table responsive striped bordered hover :items="mergedOptions.validationErrors" :fields="columns"
                    empty-text="No hay información para mostrar" thead-tr-class="table-header" class="mt-3"></b-table>
            </b-col>

            <b-col cols="12" md="12" v-else>
                <div class="no-errors">
                    <div class="success-message">
                        <i class="icon-check"></i>
                        <span>{{ mergedOptions.successMessage }}</span>
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Object,
            default: () => ({})
        },
        emitOnSuccess: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        mergedOptions() {
            return {
                title: 'Validación de Importación',
                validationErrors: [],
                successMessage: 'Importación finalizada con éxito.',
                totalImport: 0,
                textImport: false,
                errorMessage: 'Corrija los errores y vuelva a intentarlo.',
                ...this.options
            };
        }
    },
    data() {
        return {
            columns: [
                { key: 'row', label: 'Fila', class: 'text-center' },
                { key: 'message', label: 'Error', class: 'text-left' }
            ]
        };
    },
    mounted() {
        if (this.emitOnSuccess && this.mergedOptions.validationErrors && this.mergedOptions.validationErrors.length === 0) {
            this.$emit('validation-errors-present', true);
        }
    }
};
</script>

<style scoped>
.import-validation-container {
    padding: 1.5rem;
    background-color: #f9fafb;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    font-family: Arial, sans-serif;
}

.header {
    background: linear-gradient(90deg, rgba(0, 220, 212, 0.966824) 12%, #00b3c2 44%, #0089b0 100%);
    border-radius: 8px;
    color: #ffffff;
}

.header-left {
    display: flex;
    align-items: center;
}

.icon-list {
    background-color: #ffffff;
    border-radius: 50%;
    padding: 0.5rem;
    font-size: 1.2rem;
    color: #374151;
    border: 1px solid #e5e7eb;
}

.title {
    font-weight: 600;
    color: #ffffff;
}

.header-right {
    background-color: #e5e7eb;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-weight: 600;
    color: #1f2937;
    font-size: 0.875rem;
}

.no-errors {
    display: flex;
    justify-content: center;
}

.success-message {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    background-color: #d1fae5;
    border: 1px solid #a7f3d0;
    color: #065f46;
    font-weight: 600;
    border-radius: 8px;
}

.icon-check {
    font-size: 1.5rem;
    color: #10b981;
    margin-right: 0.5rem;
}

.error-message {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    background-color: #fde2e1;
    border: 1px solid #f8b4b4;
    color: #b91c1c;
    font-weight: 600;
    border-radius: 8px;
}

.icon-close {
    font-size: 1.5rem;
    color: #b91c1c;
    margin-right: 0.5rem;
}
</style>
